/**
 *
 * @summary Use in vue functional components.
 * @param {string[]} arr
 * @returns {{[key: string]: true}} Object used in element attributes
 * @example
 *  // return { xs12: true, sm8: true }
 *  transformArrayAttributes(['xs12', 'sm8'])
 */
export const transformArrayAttributes = (arr: string[]): {[key: string]: true} =>
  Object.assign({}, ...arr.map((key: string) => ({[key]: true})));

export function arrayIsEmpty(arr: []): boolean {
  return arr && arr.length === 0 && arr.constructor === Array;
}

/**
 *
 * @param {T[]} array
 * @param {number} size
 * @returns {(T[] | T[][])}
 * @example
 *  // return [[1, 2], [3, 4]]
 *  chunkRecursivity([1, 2, 3, 4], 2);
 */
export function chunkRecursivity<T>(array: T[], size: number): T[] | T[][] {
  if (!array.length) { return []; }
  const firstChunk = array.slice(0, size); // create the first chunk of the given array
  if (!firstChunk.length) {
    return array; // this is the base case to terminal the recursive
  }
  return [firstChunk].concat(chunkRecursivity(array.slice(size, array.length), size));
}
